import React, { Component } from 'react';

import _ from 'lodash';

import { connect } from 'react-redux';

import clsx from 'clsx';

import Paper from '@material-ui/core/Paper';

import ActionBar from '../../components/ActionBar';

import TreeMenuWrapper from './TreeMenuWrapper';
import CreateEntityMenu from './CreateEntityMenu';

import { isAllowed } from '../../helpers/auth';
import { Permissions } from '../../helpers/permissions';
import { findClientNode, findSiteId } from '../../helpers/treeNode';

import * as ArchitectActions from '../../actions/architectActions';
import * as ContactActions from '../../actions/contactActions';
import * as ClientActions from '../../actions/clientActions';
import * as CoreActions from '../../actions/coreActions';
import * as SiteActions from '../../actions/siteActions';

import classes from './TreePanel.module.css';

class TreePanel extends Component {

    state = {
        expandedNodes: []
    }

    async componentDidMount() {
        const { initializeTree, companyInfo } = this.props;

        if (companyInfo.companyId) {
            await initializeTree(companyInfo);
        }
    }

    async componentDidUpdate(prevProps) {
        const { initializeTree, companyInfo, nodeUpdate } = this.props;

        if (prevProps.companyInfo !== companyInfo) {
            await initializeTree(companyInfo);
        }

        if (prevProps.nodeUpdate !== nodeUpdate) {
            this.updateTree();
        }
    }

    updateExpandedNodes = node => {
        const expandedNodes = [ ...this.state.expandedNodes ];
        const targetNode = expandedNodes.find(n => n.id === node.id);

        if (targetNode) {
            const filteredNodes = expandedNodes.filter(n => n.id !== node.id);

            this.setState({
                expandedNodes: filteredNodes
            });

            return;
        }

        expandedNodes.push(node);

        this.setState({ expandedNodes });
    }

    findClientId = parentPath => {
        const parents = parentPath.split('/');

        return parents[1];
    }

    updateTree = () => {
        const { nodeUpdate, tree, setTree } = this.props;

        const update = (data, id, updatedNode) => {
            return data.reduce((r, e) => {
                if (e.id === id) {
                    e = Object.assign(e, updatedNode);
                } else {
                    if (e.nodes) update(e.nodes, id, updatedNode);
                }

                return r;
            }, []);
        };

        update(tree, nodeUpdate.id, nodeUpdate);

        setTree(tree);
    }

    handleSearch = async searchTerm => {
        const { tree, setTree, companyInfo, initializeTree } = this.props;

        if (_.isEmpty(searchTerm)) {
            await initializeTree(companyInfo);

            return;
        }

        const results = [];

        const search = (tree, searchTerm) => {
            return tree.reduce((r, e) => {
                if (e.label.toLowerCase().includes(searchTerm.toLowerCase())) {
                    results.push(e);
                } else {
                    if (e.nodes) search(e.nodes, searchTerm);
                }

                return r;
            }, []);
        };

        search(tree, searchTerm);

        setTree(results);
    }

    handleTreeClick = async node => {
        if (_.isNil(node) || _.isEmpty(node)) return;

        const {
            fetchCampusSites,
            fetchClientSites,
            fetchContacts,
            fetchAreas,
            fetchAreasByEquipmentId,
            fetchClientContacts,
            fetchEquipment,
            fetchEquipmentByAreaId,
            fetchEquipmentBySystemId,
            fetchSensors,
            fetchSiteContacts,
            fetchSitePanelData,
            fetchSystems,
            fetchSystemsByEquipmentId,
            setClient,
            setNode,
            setSite,
            setSiteNode,
            setEquipmentNode,
            setAreaNode,
            setSystemNode,
            setProgressBarLoading
        } = this.props;

        setProgressBarLoading(true);

        let clientNode, siteNode, siteName, siteId;

        setNode(node);
        let promises = [];

        switch (node.type) {
            case 'client':
                setClient(node);
                promises.push(fetchClientSites(node.id));

                process.env.contactsEnabled ?
                    promises.push(fetchClientContacts(node.id))
                    :
                    promises.push(fetchContacts(node.id));

                await Promise.all(promises.map(p => p.catch(err => err)));
                break;
            case 'site':
                clientNode = findClientNode(node);
                setClient(clientNode);
                setSite(node);

                await Promise.all([
                    fetchClientSites(clientNode.id),
                    //fetchErpLinks('site', { entityId: node.id }),
                    setSiteNode(node),
                    fetchSiteContacts(clientNode.id, node.id),
                    fetchSitePanelData(node)
                ].map(p => p.catch(err => err)));

                setProgressBarLoading(false);
                return;
            case 'campus':
                clientNode = findClientNode(node);
                setClient(clientNode);

                await Promise.all([
                    fetchCampusSites(clientNode.id, node.id),
                    fetchClientSites(clientNode.id)
                ].map(p => p.catch(err => err)));

                break;
            case 'equipment':
                clientNode = findClientNode(node);
                siteNode = this.state.expandedNodes.find(n => n.id === node.siteId);

                setClient(clientNode);
                setSite(siteNode);

                await Promise.all([
                    fetchClientSites(clientNode.id),
                    fetchEquipment(node)
                ].map(p => p.catch(err => err)));

                break;
            case 'area':
                clientNode = findClientNode(node);
                siteNode = this.state.expandedNodes.find(n => n.id === node.siteId);

                setClient(clientNode);
                setSite(siteNode);

                await Promise.all([
                    fetchClientSites(clientNode.id),
                    fetchAreas(node)
                ].map(p => p.catch(err => err)));

                break;
            case 'system':
                clientNode = findClientNode(node);
                siteNode = this.state.expandedNodes.find(n => n.id === node.siteId);

                setClient(clientNode);
                setSite(siteNode);

                await Promise.all([
                    fetchClientSites(clientNode.id),
                    fetchSystems(node)
                ].map(p => p.catch(err => err)));

                break;
            case 'equipmentItem':
                clientNode = findClientNode(node);
                siteId = findSiteId(node);
                siteName = {site: node.siteName, id: siteId};
                
                setClient(clientNode);
                setSite(siteName);

                await Promise.all([
                    setEquipmentNode(node),
                    fetchAreasByEquipmentId(node),
                    fetchSystemsByEquipmentId(node),
                    fetchSensors(node)
                ].map(p => p.catch(err => err)));

                setProgressBarLoading(false);
                return;
            case 'areaItem':
                setAreaNode(node);
                await fetchEquipmentByAreaId(node);
                setProgressBarLoading(false);
                return;
            case 'systemItem':
                setSystemNode(node);

                await Promise.all([
                    fetchEquipmentBySystemId(node),
                    fetchSensors(node)
                ].map(p => p.catch(err => err)));

                setProgressBarLoading(false);
                return;
            default:
                break;
        }

        setProgressBarLoading(false);
    }


    handleTreeToggle = async node => {
        if (_.isNil(node) || _.isEmpty(node)) return;

        const {
            fetchSiteChildNodes,
            setClient,
            setProgressBarLoading,
            setSite,
            setTree,
            tree
        } = this.props;
        const { id, type } = node;
        let data;

        this.updateExpandedNodes(node);

        if (node.isOpen) return;

        setProgressBarLoading(true);

        const search = (tree, id, nodes) => {
            return tree.reduce((r, e) => {
                if (e.id === id) {
                    e.nodes = [...nodes];
                } else {
                    if (e.nodes) search(e.nodes, id, nodes);
                }

                return r;
            }, []);
        };

        switch (type) {
            case 'client':
                setClient(node);
                break;
            case 'site':
                setSite(node);
                data = await fetchSiteChildNodes(node);

                search(tree, id, data);

                setTree(tree);
                break;
            default:
                break;
        }

        setProgressBarLoading(false);
    }

    renderToggleButton = () => {
        const { handleIsTreePanelCollapsed, isTreePanelCollapsed } = this.props;

        return (
            <span
                className={isTreePanelCollapsed ?
                    clsx(classes.toggle, classes.toggleOpenButton) :
                    clsx(classes.toggle, classes.toggleCloseButton)}
                onClick={handleIsTreePanelCollapsed}
                role="none"
            />
        );
    }

    render() {
        const {
            isTreePanelCollapsed,
            currentScopes,
            onCreateArea,
            onCreateCampus,
            onCreateClient,
            onCreateEquipment,
            onCreateSite,
            onCreateSystem,
            saveTreeReset,
            setProgressBarLoading
        } = this.props;

        const { tree } = this.props;

        const isFullArchitectAllowed = isAllowed(currentScopes, Permissions('architectFull'));

        return (
            <Paper className={classes.TreePanel}>
                { this.renderToggleButton() }
                <div className={isTreePanelCollapsed ? clsx(classes.actionBarContainer, classes.collapsed) : classes.actionBarContainer}>
                    <ActionBar
                        onSearch={this.handleSearch}
                    >
                        <CreateEntityMenu
                            hidden={!isFullArchitectAllowed}
                            onCreateArea={onCreateArea}
                            onCreateCampus={onCreateCampus}
                            onCreateClient={onCreateClient}
                            onCreateEquipment={onCreateEquipment}
                            onCreateSite={onCreateSite}
                            onCreateSystem={onCreateSystem}
                        />
                    </ActionBar>
                </div>
                <div className={isTreePanelCollapsed ? clsx(classes.treePot, classes.collapsed) : classes.treePot}>
                    <TreeMenuWrapper
                        data={tree}
                        onToggleItem={_.debounce(this.handleTreeToggle, 2000, {'leading': true })}
                        onClickItem={_.debounce(this.handleTreeClick, 2000, {'leading': true })}
                        saveTreeReset={saveTreeReset}
                        setProgressBarLoading={setProgressBarLoading}
                    />
                </div>
            </Paper>
        );
    }
}

const mapStateToProps = state => {
    return {
        companyInfo:    state.companyInfo,
        clientNodes:    state.architect.clientNodes,
        currentScopes:  state.core.currentScopes,
        nodeUpdate:     state.architect.nodeUpdate,
        selectedClient: state.client.selectedClient,
        tree:           state.architect.tree
    };
};

const mapDispatchToProps = {
    ...ArchitectActions,
    ...ContactActions,
    ...ClientActions,
    ...CoreActions,
    ...SiteActions
};

export default connect(mapStateToProps, mapDispatchToProps)(TreePanel);
